import script from "./SpjOtherFeeTab.vue?vue&type=script&setup=true&lang=js"
export * from "./SpjOtherFeeTab.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__